import React, { useEffect, useState } from "react";
import "./MyOrders.css";
import Header from "../../../Layout/Header/Header";
import Footer from "../../../Layout/Footer/Footer";
import CustomOrderCard from "../../../CustomComponents/CustomOrderCard";
import { useDispatch } from "react-redux";
import {
  getAllOrderStatusAPI,
  getMyOrdersAPI,
} from "../../../../../Store/Action/orderAction";
import EmptyOrder from "./EmptyOrder";
import CustomLoader from "../../../CustomComponents/CustomLoader/CustomLoader";
import { getLoggedInUserDetailsAPI } from "../../../../../Store/Action/UserAction";
import Icons from "../../../../../Config/Images";

const MyOrders = () => {
  const dispatch = useDispatch();
  const [collapsedIndex, setCollapsedIndex] = useState(null);
  const [refreshState, setRefreshState] = useState(0);
  const [myOrders, setMyOrders] = useState([]);
  const [orderStatus, setOrderStatus] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("ongoing");
  const [isWastageEnabled, setIsWastageEnabled] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        const booleanValue =
          result?.data?.[0]?.user_generic_data_value?.[0]
            ?.user_generic_data_boolean_value;
        setIsWastageEnabled(booleanValue === 1);
      }),
    );
  }, [dispatch]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCollapsedIndex(null);
  };

  useEffect(() => {
    dispatch(
      getAllOrderStatusAPI({}, (result) => {
        setOrderStatus(result || []);
      }),
    );
  }, [dispatch]);

  const filteredStatusIds = React.useMemo(() => {
    if (!orderStatus?.length) return [];

    if (activeTab === "ongoing") {
      return orderStatus
        .filter(
          (s) =>
            !["delivered", "cancel", "return"].includes(
              s?.order_status_name?.toLowerCase(),
            ),
        )
        .map((s) => s.order_status_id);
    }

    if (activeTab === "completed") {
      return orderStatus
        .filter((s) => s?.order_status_name?.toLowerCase() === "delivered")
        .map((s) => s.order_status_id);
    }

    if (activeTab === "cancelReturn") {
      return orderStatus
        .filter((s) =>
          ["cancel"].includes(s?.order_status_name?.toLowerCase()),
        )
        .map((s) => s.order_status_id);
    }

    return [];
  }, [orderStatus, activeTab]);

  useEffect(() => {
    if (!filteredStatusIds.length) return;

    setIsLoading(true);

    dispatch(
      getMyOrdersAPI(
        {
          order_status_id: filteredStatusIds.join(","),
          search_query: searchQuery?.trim() || undefined,
        },
        (result) => {
          setMyOrders(result?.data || []);
          setIsLoading(false);
        },
      ),
    );
  }, [activeTab, refreshState, filteredStatusIds, searchQuery]);

  const handleToggleCollapse = (index) => {
    setCollapsedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const onGetOrderList = () => {
    setRefreshState((prev) => prev + 1);
  };
  const triggerSearch = () => {
    const value = searchInput.trim();
    // if (!value) return;
    setSearchQuery(value);
  };

  return (
    <>
      <Header />
      <div className="my-orders-div">
        <div className="order-account-header">
          <h3>My Orders</h3>
        </div>
        <div className="order-search-wrapper">
          <span className="search-icon" onClick={triggerSearch}>
            <img src={Icons.searchIcon} alt="search" />
          </span>

          <input
            type="text"
            placeholder="Search by order number"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                triggerSearch();
              }
            }}
          />
          {/* Clear (Cross) Icon */}
          {searchInput && (
            <span
              className="clear-icon"
              onClick={() => {
                setSearchInput("");
                setSearchQuery(""); // trigger API with no search
              }}
            >
              ✕
            </span>
          )}
        </div>

        <div className="divider" />

        <div className="tab-buttons" style={{ marginBottom: "20px" }}>
          <div
            className={`tab-button ${activeTab === "ongoing" ? "active" : ""}`}
            onClick={() => handleTabChange("ongoing")}
          >
            <p className="full-text">Ongoing Orders</p>
            <p className="small-text">Ongoing</p>
          </div>
          <div
            className={`tab-button ${
              activeTab === "completed" ? "active" : ""
            }`}
            onClick={() => handleTabChange("completed")}
          >
            <p className="full-text">Completed Orders</p>
            <p className="small-text">Completed</p>
          </div>
          <div
            className={`tab-button ${
              activeTab === "cancelReturn" ? "active" : ""
            }`}
            onClick={() => handleTabChange("cancelReturn")}
          >
            <p className="full-text">Cancelled</p>
            <p className="small-text" >Cancelled</p>
          </div>
        </div>

        {isLoading ? (
          <div className="loaderContainer">
            <CustomLoader />
          </div>
        ) : myOrders?.length === 0 ? (
          <EmptyOrder />
        ) : (
          <div className="my-orders-content-div">
            {myOrders?.map((order, index) => (
              <CustomOrderCard
                key={order?.order_id}
                order={order}
                isCollapsed={collapsedIndex === index}
                onToggleCollapse={() => handleToggleCollapse(index)}
                activeTab={activeTab}
                isWastageEnabled={isWastageEnabled}
                isTrackOrderVisible={
                  order?.order_status_name?.toLowerCase() !== "pending" &&
                  order?.order_status_name?.toLowerCase() !==
                    "send to the manufacturer"
                }
                onGetOrderList={onGetOrderList}
              />
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default MyOrders;
